import { Component, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'sidebar-right',
	templateUrl: './sidebar-right.component.html',
	standalone: false
})

export class SidebarRightComponent {
	@Output() appSidebarEndMobileToggled = new EventEmitter<boolean>();

	toggleAppSidebarEndMobile() {
		console.log('called');
		this.appSidebarEndMobileToggled.emit(true);
	}
}
